/**
 * Game Configuration
 * Centralized constants for easy tuning and balancing
 */

// Physics constants
export const PHYSICS = {
  GRAVITY: 1500,
  WALK_SPEED: 200,
  RUN_SPEED: 320,
  JUMP_VELOCITY: 420,
  MAX_FALL_SPEED: 1000,
  FRICTION: 1500,
  ACCELERATION: 1200,
  RUN_ACCELERATION: 1500,
};

// Game feel settings
export const GAME_FEEL = {
  COYOTE_TIME: 0.10,        // Grace period after leaving platform
  JUMP_BUFFER_TIME: 0.12,   // Input buffer for jump
  JUMP_CUT_MULTIPLIER: 2.2, // Extra gravity when releasing jump
  DOUBLE_JUMP_MULTIPLIER: Math.sqrt(1.5), // Second jump height multiplier
};

// Rendering settings
export const RENDERING = {
  MAX_DPR: 1.5,              // Cap device pixel ratio for performance
  DEFAULT_VIEW_SCALE: 1.25,  // Default zoom level
  SCALE_STEPS: [1.0, 1.25, 1.5, 1.75, 2.0], // Available zoom levels
};

// Camera settings
export const CAMERA = {
  HORIZONTAL_SMOOTHING: 0.1,
  VERTICAL_SMOOTHING: 0.15,
  VERTICAL_FOLLOW_THRESHOLD: 200, // Pixels above ground to start vertical follow
  BOTTOM_FOLLOW_THRESHOLD: 100,   // Pixels below ground to follow down
};

// Audio settings
export const AUDIO = {
  MUSIC_BASE_VOLUME: 0.22,
  SFX_BASE_VOLUME: 0.7,
  MASTER_VOLUME: 1.0,
};

// World generation
export const WORLD = {
  CHUNK_SIZE: 800,           // Width of tree/platform generation chunks
  PLATFORM_CHUNK_W: 1200,
  PLATFORM_CHUNK_H: 800,
  SKY_CLOUD_SPEED: 64,       // Base cloud drift speed
  UNDERGROUND_TILE_SIZE: 16,
};

// Player settings
export const PLAYER = {
  WIDTH: 24,
  HEIGHT: 36,
  INITIAL_X: 48,
  INITIAL_Y: 0,
};

// UI settings
export const UI = {
  HINT_MIN_SHOW_SEC: 3.5,
  HINT_FORCE_HIDE_SEC: 10,
  TOAST_DURATION: 2.6,
  DIALOGUE_TEXT_SPEED: 0.03, // seconds per character
};

// Enemy settings
export const ENEMIES = {
  SPIDER_SPEED: 80,
  SPIDER_PATROL_RANGE: 150,
  TITAN_HP: 5,
  TITAN_SPEED: 60,
};

// Combat settings
export const COMBAT = {
  SWORD_RANGE: 40,
  SWORD_DAMAGE: 1,
  RAYGUN_PROJECTILE_SPEED: 400,
  RAYGUN_DAMAGE: 1,
};

// Storage keys
export const STORAGE_KEYS = {
  VOLUME_MASTER: 'volumeMaster',
  VOLUME_MUSIC: 'volumeMusic',
  VOLUME_SFX: 'volumeSfx',
  VIEW_SCALE: 'viewScale',
  CONTROL_GUIDES: 'controlGuides',
  KEYBOARD_LAYOUT: 'keyboardLayout',
  SAVE_GAME: 'savegame',
  ALL_MUTED: 'allMuted',
};
